import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EntityViewService } from 'src/app/services/entity-view.service';
import union from 'lodash/union';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-rewardtimeline',
  templateUrl: './rewardtimeline.component.html',
  styleUrls: ['./rewardtimeline.component.sass']
})
export class RewardtimelineComponent implements OnInit {
  @Input() record: any; 
  @Input() field: any;  
  rewards: any; 

  entity: any;
  type = 'season-pass';
  parsedSeasonPass: any = [];
  isLoading: boolean;
  id: any;
  constructor(
    private entityViewService: EntityViewService,
    private route: ActivatedRoute,
    private titleService: Title
  ) {}

  async ngOnInit() {
    this.isLoading = true;
    const routeParams = this.route.snapshot.paramMap;

    this.id = Number(routeParams.get('id'));

    await this.entityViewService
      .getEntity(this.type, { query: { id: this.id }, autopopulate: true })
      .then((result: any) => {
        if (result) {
          this.entity = result;
          if (this.entity.name) {
            this.titleService.setTitle(this.entity.name);
          }
        }
      });

    this.parseSeasonPass();
    console.log('Parsed Season Pass: ', this.parsedSeasonPass);
    this.isLoading = false;
  }


  parseSeasonPass() {
    this.parsedSeasonPass = [];
    
    if (!this.entity) return;

    // Get stageMilestones safely, handling null/undefined cases
    const paidStageMilestones = this.entity.paid?.stageMilestone || [];
    const freeStageMilestones = this.entity.free?.stageMilestone || [];
    
    // Check if we have at least one track with stages
    if (paidStageMilestones.length === 0 && freeStageMilestones.length === 0) {
      return;
    }

    // Merge and sort stage milestones
    let mergedStageMilestones: Array<number> = union(
      paidStageMilestones,
      freeStageMilestones
    );
    
    mergedStageMilestones = mergedStageMilestones.sort((a, b) => a - b);

    for (let stage of mergedStageMilestones) {
      const stageData: any = { stage: stage };
      
      // Check if this stage exists in free track
      if (freeStageMilestones.includes(stage)) {
        const freeIndex = freeStageMilestones.indexOf(stage);
        if (this.entity.free?.free && this.entity.free.free[freeIndex]) {
          stageData.free = this.entity.free.free[freeIndex];
        }
      }
      
      // Check if this stage exists in paid track  
      if (paidStageMilestones.includes(stage)) {
        const paidIndex = paidStageMilestones.indexOf(stage);
        if (this.entity.paid?.paid && this.entity.paid.paid[paidIndex]) {
          stageData.paid = this.entity.paid.paid[paidIndex];
        }
      }
      
      this.parsedSeasonPass.push(stageData);
    }
  }
  getRewardImage(reward: any): string {
    let imagePath = '';
  
    if (!reward || !reward.id) {
      return 'https://placeholder.com/100';
    } else {
      switch (reward.lineItemType) {
        case 'Item':
          imagePath = reward.id?.thumbnail_ref?.thumbnails?.[0]?.path || 'https://placeholder.com/100';
          break;
        case 'Currency':
          imagePath = reward.id?.thumbnail_ref?.thumbnails?.[0]?.path || reward.id?.thumbnails?.[2]?.path || 'https://placeholder.com/100';
          break;
        case 'Titles':
          imagePath = 'https://d3tfb94dc03jqa.cloudfront.net/images/titles/title_default/title_default_128.png';
          break;
        case 'Nurture':
          imagePath = reward.id?.coinThumbnail_ref?.thumbnails?.[0]?.path || reward.id?.sproutImage_ref?.thumbnails?.[0]?.path || 'https://placeholder.com/100';
          break;
        case 'SeedPackBox':
          imagePath = reward.id?.box_image_empty_ref?.thumbnails?.[0]?.path || 'https://placeholder.com/100';
          break;
        case 'DynamicMysteryBox':
          imagePath = reward.id?.asset3D_ref?.thumbnails?.[0]?.path || 'https://placeholder.com/100';
          break;
        default:
          imagePath = 'https://placeholder.com/100';
          break;
      }
    }
  
    return imagePath;
  }
  
}
